import * as CONST from 'Reducers/Countries/const'

/**
 * Get countries
 *
 * @returns Object
 */
export function getCountries() {
  return {
    type: CONST.GET_COUNTRIES,
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Countries/actions.js